/**
 * @generated SignedSource<<da234b39e388d56e425c82824c1c2324>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patternId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showTenWeeks"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day1"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day2"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day3"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day4"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day5"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day6"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk10day7"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day1"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day2"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day3"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day4"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day5"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day6"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk1day7"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day1"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day2"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day3"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day4"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day5"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day6"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk2day7"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day1"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day2"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day3"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day4"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day5"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day6"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk3day7"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day1"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day2"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day3"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day4"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day5"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day6"
},
v41 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk4day7"
},
v42 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day1"
},
v43 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day2"
},
v44 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day3"
},
v45 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day4"
},
v46 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day5"
},
v47 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day6"
},
v48 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk5day7"
},
v49 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day1"
},
v50 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day2"
},
v51 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day3"
},
v52 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day4"
},
v53 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day5"
},
v54 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day6"
},
v55 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk6day7"
},
v56 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day1"
},
v57 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day2"
},
v58 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day3"
},
v59 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day4"
},
v60 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day5"
},
v61 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day6"
},
v62 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk7day7"
},
v63 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day1"
},
v64 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day2"
},
v65 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day3"
},
v66 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day4"
},
v67 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day5"
},
v68 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day6"
},
v69 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk8day7"
},
v70 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day1"
},
v71 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day2"
},
v72 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day3"
},
v73 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day4"
},
v74 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day5"
},
v75 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day6"
},
v76 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wk9day7"
},
v77 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patternId"
  }
],
v78 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v79 = {
  "kind": "Variable",
  "name": "serviceDate",
  "variableName": "serviceDate"
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v84 = [
  {
    "kind": "Variable",
    "name": "serviceDate",
    "variableName": "date"
  }
],
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeparture",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceDay",
  "storageKey": null
},
v87 = [
  (v79/*: any*/)
],
v88 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Stoptime",
    "kind": "LinkedField",
    "name": "departureStoptime",
    "plural": false,
    "selections": [
      (v85/*: any*/)
    ],
    "storageKey": null
  },
  (v80/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v59/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v62/*: any*/),
      (v63/*: any*/),
      (v64/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v67/*: any*/),
      (v68/*: any*/),
      (v69/*: any*/),
      (v70/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v74/*: any*/),
      (v75/*: any*/),
      (v76/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_ScheduleContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v77/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SchedulePatternFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v78/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cancelationEndDate",
                "variableName": "cancelationEndDate"
              },
              {
                "kind": "Variable",
                "name": "cancelationStartDate",
                "variableName": "cancelationStartDate"
              },
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              },
              (v79/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ScheduleRouteFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "firstDepartures",
        "args": (v77/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "showTenWeeks",
                "variableName": "showTenWeeks"
              },
              {
                "kind": "Variable",
                "name": "wk10day1",
                "variableName": "wk10day1"
              },
              {
                "kind": "Variable",
                "name": "wk10day2",
                "variableName": "wk10day2"
              },
              {
                "kind": "Variable",
                "name": "wk10day3",
                "variableName": "wk10day3"
              },
              {
                "kind": "Variable",
                "name": "wk10day4",
                "variableName": "wk10day4"
              },
              {
                "kind": "Variable",
                "name": "wk10day5",
                "variableName": "wk10day5"
              },
              {
                "kind": "Variable",
                "name": "wk10day6",
                "variableName": "wk10day6"
              },
              {
                "kind": "Variable",
                "name": "wk10day7",
                "variableName": "wk10day7"
              },
              {
                "kind": "Variable",
                "name": "wk1day1",
                "variableName": "wk1day1"
              },
              {
                "kind": "Variable",
                "name": "wk1day2",
                "variableName": "wk1day2"
              },
              {
                "kind": "Variable",
                "name": "wk1day3",
                "variableName": "wk1day3"
              },
              {
                "kind": "Variable",
                "name": "wk1day4",
                "variableName": "wk1day4"
              },
              {
                "kind": "Variable",
                "name": "wk1day5",
                "variableName": "wk1day5"
              },
              {
                "kind": "Variable",
                "name": "wk1day6",
                "variableName": "wk1day6"
              },
              {
                "kind": "Variable",
                "name": "wk1day7",
                "variableName": "wk1day7"
              },
              {
                "kind": "Variable",
                "name": "wk2day1",
                "variableName": "wk2day1"
              },
              {
                "kind": "Variable",
                "name": "wk2day2",
                "variableName": "wk2day2"
              },
              {
                "kind": "Variable",
                "name": "wk2day3",
                "variableName": "wk2day3"
              },
              {
                "kind": "Variable",
                "name": "wk2day4",
                "variableName": "wk2day4"
              },
              {
                "kind": "Variable",
                "name": "wk2day5",
                "variableName": "wk2day5"
              },
              {
                "kind": "Variable",
                "name": "wk2day6",
                "variableName": "wk2day6"
              },
              {
                "kind": "Variable",
                "name": "wk2day7",
                "variableName": "wk2day7"
              },
              {
                "kind": "Variable",
                "name": "wk3day1",
                "variableName": "wk3day1"
              },
              {
                "kind": "Variable",
                "name": "wk3day2",
                "variableName": "wk3day2"
              },
              {
                "kind": "Variable",
                "name": "wk3day3",
                "variableName": "wk3day3"
              },
              {
                "kind": "Variable",
                "name": "wk3day4",
                "variableName": "wk3day4"
              },
              {
                "kind": "Variable",
                "name": "wk3day5",
                "variableName": "wk3day5"
              },
              {
                "kind": "Variable",
                "name": "wk3day6",
                "variableName": "wk3day6"
              },
              {
                "kind": "Variable",
                "name": "wk3day7",
                "variableName": "wk3day7"
              },
              {
                "kind": "Variable",
                "name": "wk4day1",
                "variableName": "wk4day1"
              },
              {
                "kind": "Variable",
                "name": "wk4day2",
                "variableName": "wk4day2"
              },
              {
                "kind": "Variable",
                "name": "wk4day3",
                "variableName": "wk4day3"
              },
              {
                "kind": "Variable",
                "name": "wk4day4",
                "variableName": "wk4day4"
              },
              {
                "kind": "Variable",
                "name": "wk4day5",
                "variableName": "wk4day5"
              },
              {
                "kind": "Variable",
                "name": "wk4day6",
                "variableName": "wk4day6"
              },
              {
                "kind": "Variable",
                "name": "wk4day7",
                "variableName": "wk4day7"
              },
              {
                "kind": "Variable",
                "name": "wk5day1",
                "variableName": "wk5day1"
              },
              {
                "kind": "Variable",
                "name": "wk5day2",
                "variableName": "wk5day2"
              },
              {
                "kind": "Variable",
                "name": "wk5day3",
                "variableName": "wk5day3"
              },
              {
                "kind": "Variable",
                "name": "wk5day4",
                "variableName": "wk5day4"
              },
              {
                "kind": "Variable",
                "name": "wk5day5",
                "variableName": "wk5day5"
              },
              {
                "kind": "Variable",
                "name": "wk5day6",
                "variableName": "wk5day6"
              },
              {
                "kind": "Variable",
                "name": "wk5day7",
                "variableName": "wk5day7"
              },
              {
                "kind": "Variable",
                "name": "wk6day1",
                "variableName": "wk6day1"
              },
              {
                "kind": "Variable",
                "name": "wk6day2",
                "variableName": "wk6day2"
              },
              {
                "kind": "Variable",
                "name": "wk6day3",
                "variableName": "wk6day3"
              },
              {
                "kind": "Variable",
                "name": "wk6day4",
                "variableName": "wk6day4"
              },
              {
                "kind": "Variable",
                "name": "wk6day5",
                "variableName": "wk6day5"
              },
              {
                "kind": "Variable",
                "name": "wk6day6",
                "variableName": "wk6day6"
              },
              {
                "kind": "Variable",
                "name": "wk6day7",
                "variableName": "wk6day7"
              },
              {
                "kind": "Variable",
                "name": "wk7day1",
                "variableName": "wk7day1"
              },
              {
                "kind": "Variable",
                "name": "wk7day2",
                "variableName": "wk7day2"
              },
              {
                "kind": "Variable",
                "name": "wk7day3",
                "variableName": "wk7day3"
              },
              {
                "kind": "Variable",
                "name": "wk7day4",
                "variableName": "wk7day4"
              },
              {
                "kind": "Variable",
                "name": "wk7day5",
                "variableName": "wk7day5"
              },
              {
                "kind": "Variable",
                "name": "wk7day6",
                "variableName": "wk7day6"
              },
              {
                "kind": "Variable",
                "name": "wk7day7",
                "variableName": "wk7day7"
              },
              {
                "kind": "Variable",
                "name": "wk8day1",
                "variableName": "wk8day1"
              },
              {
                "kind": "Variable",
                "name": "wk8day2",
                "variableName": "wk8day2"
              },
              {
                "kind": "Variable",
                "name": "wk8day3",
                "variableName": "wk8day3"
              },
              {
                "kind": "Variable",
                "name": "wk8day4",
                "variableName": "wk8day4"
              },
              {
                "kind": "Variable",
                "name": "wk8day5",
                "variableName": "wk8day5"
              },
              {
                "kind": "Variable",
                "name": "wk8day6",
                "variableName": "wk8day6"
              },
              {
                "kind": "Variable",
                "name": "wk8day7",
                "variableName": "wk8day7"
              },
              {
                "kind": "Variable",
                "name": "wk9day1",
                "variableName": "wk9day1"
              },
              {
                "kind": "Variable",
                "name": "wk9day2",
                "variableName": "wk9day2"
              },
              {
                "kind": "Variable",
                "name": "wk9day3",
                "variableName": "wk9day3"
              },
              {
                "kind": "Variable",
                "name": "wk9day4",
                "variableName": "wk9day4"
              },
              {
                "kind": "Variable",
                "name": "wk9day5",
                "variableName": "wk9day5"
              },
              {
                "kind": "Variable",
                "name": "wk9day6",
                "variableName": "wk9day6"
              },
              {
                "kind": "Variable",
                "name": "wk9day7",
                "variableName": "wk9day7"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ScheduleFirstDeparturesFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v59/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v62/*: any*/),
      (v63/*: any*/),
      (v64/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v67/*: any*/),
      (v68/*: any*/),
      (v69/*: any*/),
      (v70/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v74/*: any*/),
      (v75/*: any*/),
      (v76/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_ScheduleContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v77/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          (v80/*: any*/),
          (v81/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              (v80/*: any*/),
              (v82/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v78/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          (v83/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Agency",
            "kind": "LinkedField",
            "name": "agency",
            "plural": false,
            "selections": [
              (v82/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fareUrl",
                "storageKey": null
              },
              (v80/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "patterns",
            "plural": true,
            "selections": [
              (v81/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "directionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stops",
                "plural": true,
                "selections": [
                  (v82/*: any*/),
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "activeDates",
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trips",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": "day",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeDates",
                    "storageKey": null
                  },
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v84/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v84/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              (v80/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "ROUTE",
                      "STOPS_ON_PATTERN"
                    ]
                  }
                ],
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": [
                  (v80/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alertSeverityLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEndDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveStartDate",
                    "storageKey": null
                  }
                ],
                "storageKey": "alerts(types:[\"ROUTE\",\"STOPS_ON_PATTERN\"])"
              },
              {
                "alias": "trips",
                "args": (v87/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v87/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stop",
                        "plural": false,
                        "selections": [
                          (v80/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "realtimeState",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledArrival",
                        "storageKey": null
                      },
                      (v85/*: any*/),
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v80/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "items": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "end",
                            "variableName": "cancelationEndDate"
                          },
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "cancelationStartDate"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "runningTimeRanges.0"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "runningTimeRanges"
                  }
                ],
                "concreteType": "TripOnServiceDate",
                "kind": "LinkedField",
                "name": "canceledTrips",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          (v81/*: any*/),
                          (v80/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v83/*: any*/),
                      (v80/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v80/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "firstDepartures",
        "args": (v77/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "alias": "wk1mon",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day1"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1tue",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day2"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1wed",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day3"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1thu",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day4"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1fri",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day5"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1sat",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day6"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk1sun",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk1day7"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2mon",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day1"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2tue",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day2"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2wed",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day3"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2thu",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day4"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2fri",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day5"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2sat",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day6"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk2sun",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk2day7"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3mon",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day1"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3tue",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day2"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3wed",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day3"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3thu",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day4"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3fri",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day5"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3sat",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day6"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk3sun",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk3day7"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4mon",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day1"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4tue",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day2"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4wed",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day3"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4thu",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day4"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4fri",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day5"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4sat",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day6"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk4sun",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk4day7"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5mon",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day1"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5tue",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day2"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5wed",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day3"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5thu",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day4"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5fri",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day5"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5sat",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day6"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "alias": "wk5sun",
            "args": [
              {
                "kind": "Variable",
                "name": "serviceDate",
                "variableName": "wk5day7"
              }
            ],
            "concreteType": "Trip",
            "kind": "LinkedField",
            "name": "tripsForDate",
            "plural": true,
            "selections": (v88/*: any*/),
            "storageKey": null
          },
          {
            "condition": "showTenWeeks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "wk6mon",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day1"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6tue",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day2"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6wed",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day3"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6thu",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day4"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6fri",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day5"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6sat",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day6"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk6sun",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk6day7"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7mon",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day1"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7tue",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day2"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7wed",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day3"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7thu",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day4"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7fri",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day5"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7sat",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day6"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk7sun",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk7day7"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8mon",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day1"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8tue",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day2"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8wed",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day3"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8thu",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day4"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8fri",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day5"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8sat",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day6"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk8sun",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk8day7"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9mon",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day1"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9tue",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day2"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9wed",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day3"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9thu",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day4"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9fri",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day5"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9sat",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day6"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk9sun",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk9day7"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10mon",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day1"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10tue",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day2"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10wed",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day3"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10thu",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day4"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10fri",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day5"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10sat",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day6"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              },
              {
                "alias": "wk10sun",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "wk10day7"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": (v88/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v80/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64c205c607cf1b6f8b3080b3fbb1901c",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_ScheduleContainer_Query",
    "operationKind": "query",
    "text": "query routeRoutes_ScheduleContainer_Query(\n  $showTenWeeks: Boolean!\n  $routeId: String!\n  $patternId: String!\n  $serviceDate: String!\n  $date: String!\n  $cancelationStartDate: OffsetDateTime!\n  $cancelationEndDate: OffsetDateTime!\n  $wk1day1: String!\n  $wk1day2: String!\n  $wk1day3: String!\n  $wk1day4: String!\n  $wk1day5: String!\n  $wk1day6: String!\n  $wk1day7: String!\n  $wk2day1: String!\n  $wk2day2: String!\n  $wk2day3: String!\n  $wk2day4: String!\n  $wk2day5: String!\n  $wk2day6: String!\n  $wk2day7: String!\n  $wk3day1: String!\n  $wk3day2: String!\n  $wk3day3: String!\n  $wk3day4: String!\n  $wk3day5: String!\n  $wk3day6: String!\n  $wk3day7: String!\n  $wk4day1: String!\n  $wk4day2: String!\n  $wk4day3: String!\n  $wk4day4: String!\n  $wk4day5: String!\n  $wk4day6: String!\n  $wk4day7: String!\n  $wk5day1: String!\n  $wk5day2: String!\n  $wk5day3: String!\n  $wk5day4: String!\n  $wk5day5: String!\n  $wk5day6: String!\n  $wk5day7: String!\n  $wk6day1: String\n  $wk6day2: String\n  $wk6day3: String\n  $wk6day4: String\n  $wk6day5: String\n  $wk6day6: String\n  $wk6day7: String\n  $wk7day1: String\n  $wk7day2: String\n  $wk7day3: String\n  $wk7day4: String\n  $wk7day5: String\n  $wk7day6: String\n  $wk7day7: String\n  $wk8day1: String\n  $wk8day2: String\n  $wk8day3: String\n  $wk8day4: String\n  $wk8day5: String\n  $wk8day6: String\n  $wk8day7: String\n  $wk9day1: String\n  $wk9day2: String\n  $wk9day3: String\n  $wk9day4: String\n  $wk9day5: String\n  $wk9day6: String\n  $wk9day7: String\n  $wk10day1: String\n  $wk10day2: String\n  $wk10day3: String\n  $wk10day4: String\n  $wk10day5: String\n  $wk10day6: String\n  $wk10day7: String\n) {\n  pattern(id: $patternId) {\n    ...SchedulePatternFragment\n    id\n  }\n  route(id: $routeId) {\n    ...ScheduleRouteFragment_1dTNnc\n    id\n  }\n  firstDepartures: pattern(id: $patternId) {\n    ...ScheduleFirstDeparturesFragment_3WV8Zr\n    id\n  }\n}\n\nfragment RouteAgencyInfo_route on Route {\n  agency {\n    name\n    url\n    fareUrl\n    id\n  }\n}\n\nfragment RoutePatternSelectContainerFragment_route_19b1FI on Route {\n  shortName\n  mode\n  type\n  color\n  gtfsId\n  patterns {\n    code\n    directionId\n    headsign\n    stops {\n      name\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    tripsForDate(serviceDate: $date) {\n      stoptimes: stoptimesForDate(serviceDate: $date) {\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ScheduleFirstDeparturesFragment_3WV8Zr on Pattern {\n  wk1mon: tripsForDate(serviceDate: $wk1day1) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1tue: tripsForDate(serviceDate: $wk1day2) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1wed: tripsForDate(serviceDate: $wk1day3) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1thu: tripsForDate(serviceDate: $wk1day4) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1fri: tripsForDate(serviceDate: $wk1day5) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1sat: tripsForDate(serviceDate: $wk1day6) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk1sun: tripsForDate(serviceDate: $wk1day7) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2mon: tripsForDate(serviceDate: $wk2day1) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2tue: tripsForDate(serviceDate: $wk2day2) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2wed: tripsForDate(serviceDate: $wk2day3) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2thu: tripsForDate(serviceDate: $wk2day4) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2fri: tripsForDate(serviceDate: $wk2day5) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2sat: tripsForDate(serviceDate: $wk2day6) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk2sun: tripsForDate(serviceDate: $wk2day7) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3mon: tripsForDate(serviceDate: $wk3day1) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3tue: tripsForDate(serviceDate: $wk3day2) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3wed: tripsForDate(serviceDate: $wk3day3) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3thu: tripsForDate(serviceDate: $wk3day4) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3fri: tripsForDate(serviceDate: $wk3day5) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3sat: tripsForDate(serviceDate: $wk3day6) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk3sun: tripsForDate(serviceDate: $wk3day7) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4mon: tripsForDate(serviceDate: $wk4day1) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4tue: tripsForDate(serviceDate: $wk4day2) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4wed: tripsForDate(serviceDate: $wk4day3) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4thu: tripsForDate(serviceDate: $wk4day4) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4fri: tripsForDate(serviceDate: $wk4day5) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4sat: tripsForDate(serviceDate: $wk4day6) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk4sun: tripsForDate(serviceDate: $wk4day7) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5mon: tripsForDate(serviceDate: $wk5day1) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5tue: tripsForDate(serviceDate: $wk5day2) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5wed: tripsForDate(serviceDate: $wk5day3) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5thu: tripsForDate(serviceDate: $wk5day4) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5fri: tripsForDate(serviceDate: $wk5day5) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5sat: tripsForDate(serviceDate: $wk5day6) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk5sun: tripsForDate(serviceDate: $wk5day7) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6mon: tripsForDate(serviceDate: $wk6day1) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6tue: tripsForDate(serviceDate: $wk6day2) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6wed: tripsForDate(serviceDate: $wk6day3) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6thu: tripsForDate(serviceDate: $wk6day4) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6fri: tripsForDate(serviceDate: $wk6day5) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6sat: tripsForDate(serviceDate: $wk6day6) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk6sun: tripsForDate(serviceDate: $wk6day7) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7mon: tripsForDate(serviceDate: $wk7day1) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7tue: tripsForDate(serviceDate: $wk7day2) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7wed: tripsForDate(serviceDate: $wk7day3) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7thu: tripsForDate(serviceDate: $wk7day4) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7fri: tripsForDate(serviceDate: $wk7day5) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7sat: tripsForDate(serviceDate: $wk7day6) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk7sun: tripsForDate(serviceDate: $wk7day7) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8mon: tripsForDate(serviceDate: $wk8day1) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8tue: tripsForDate(serviceDate: $wk8day2) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8wed: tripsForDate(serviceDate: $wk8day3) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8thu: tripsForDate(serviceDate: $wk8day4) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8fri: tripsForDate(serviceDate: $wk8day5) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8sat: tripsForDate(serviceDate: $wk8day6) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk8sun: tripsForDate(serviceDate: $wk8day7) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9mon: tripsForDate(serviceDate: $wk9day1) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9tue: tripsForDate(serviceDate: $wk9day2) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9wed: tripsForDate(serviceDate: $wk9day3) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9thu: tripsForDate(serviceDate: $wk9day4) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9fri: tripsForDate(serviceDate: $wk9day5) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9sat: tripsForDate(serviceDate: $wk9day6) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk9sun: tripsForDate(serviceDate: $wk9day7) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10mon: tripsForDate(serviceDate: $wk10day1) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10tue: tripsForDate(serviceDate: $wk10day2) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10wed: tripsForDate(serviceDate: $wk10day3) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10thu: tripsForDate(serviceDate: $wk10day4) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10fri: tripsForDate(serviceDate: $wk10day5) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10sat: tripsForDate(serviceDate: $wk10day6) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n  wk10sun: tripsForDate(serviceDate: $wk10day7) @include(if: $showTenWeeks) {\n    departureStoptime {\n      scheduledDeparture\n    }\n    id\n  }\n}\n\nfragment SchedulePatternFragment on Pattern {\n  id\n  code\n  stops {\n    id\n    name\n  }\n}\n\nfragment ScheduleRouteFragment_1dTNnc on Route {\n  gtfsId\n  color\n  shortName\n  longName\n  mode\n  type\n  ...RouteAgencyInfo_route\n  ...RoutePatternSelectContainerFragment_route_19b1FI\n  agency {\n    name\n    phone\n    id\n  }\n  patterns {\n    alerts(types: [ROUTE, STOPS_ON_PATTERN]) {\n      id\n      alertSeverityLevel\n      effectiveEndDate\n      effectiveStartDate\n    }\n    headsign\n    code\n    stops {\n      name\n      id\n    }\n    trips: tripsForDate(serviceDate: $serviceDate) {\n      stoptimes: stoptimesForDate(serviceDate: $serviceDate) {\n        stop {\n          id\n        }\n        realtimeState\n        scheduledArrival\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    canceledTrips(runningTimeRanges: [{start: $cancelationStartDate, end: $cancelationEndDate}]) {\n      serviceDate\n      trip {\n        pattern {\n          code\n          id\n        }\n        gtfsId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "a698e000d64fe5ab7baa4b83f4e94021";

export default node;
